import { render, staticRenderFns } from "./addStorage.vue?vue&type=template&id=a166b8e0&scoped=true"
import script from "./addStorage.vue?vue&type=script&lang=js"
export * from "./addStorage.vue?vue&type=script&lang=js"
import style0 from "./addStorage.vue?vue&type=style&index=0&id=a166b8e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a166b8e0",
  null
  
)

export default component.exports